import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Textarea } from '@/components/ui/textarea';
import type { PollQuestion, PollAnswer } from '../types';

interface PollQuestionViewProps {
  question: PollQuestion;
  answer: PollAnswer;
  onChange: (answer: PollAnswer) => void;
  disabled?: boolean;
}

export function PollQuestionView({ question, answer, onChange, disabled }: PollQuestionViewProps) {
  const selectedOptions = answer.selectedOptions || [];

  if (question.type === 'free_text') {
    return (
      <div className="space-y-2">
        <Label className="text-base font-medium">
          {question.text}
          {question.required && <span className="text-destructive ml-1">*</span>}
        </Label>
        <Textarea
          value={answer.textAnswer || ''}
          onChange={(e) => onChange({ ...answer, textAnswer: e.target.value })}
          placeholder="Type your answer..."
          disabled={disabled}
        />
      </div>
    );
  }

  const isSingle = question.type === 'single_choice';

  return (
    <div className="space-y-3">
      <Label className="text-base font-medium">
        {question.text}
        {question.required && <span className="text-destructive ml-1">*</span>}
      </Label>
      <p className="text-xs text-muted-foreground">
        {isSingle ? 'Select one option' : 'Select all that apply'}
      </p>
      <div className="space-y-2">
        {(question.options || []).map((opt, i) => {
          const isChecked = selectedOptions.includes(i);
          return (
            <div key={i} className="flex items-center gap-2">
              <Checkbox
                id={`${question.questionId}-opt-${i}`}
                checked={isChecked}
                disabled={disabled}
                onCheckedChange={(checked) => {
                  let newSelected: number[];
                  if (isSingle) {
                    newSelected = checked ? [i] : [];
                  } else {
                    newSelected = checked
                      ? [...selectedOptions, i]
                      : selectedOptions.filter((idx) => idx !== i);
                  }
                  onChange({ ...answer, selectedOptions: newSelected });
                }}
              />
              <Label htmlFor={`${question.questionId}-opt-${i}`} className="text-sm font-normal">
                {opt}
              </Label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
